import React from "react";
import styled from "styled-components";

// Styled Components pour le LogoBanner responsive
const BannerWrapper = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 40px 15px;
  }

  @media (max-width: 576px) {
    /* Option 1: Masquer sur mobile - décommentez si souhaité */
    /* display: none; */
    
    /* Option 2: Scroll horizontal sur mobile */
    padding: 30px 10px;
  }
`;

const BannerTitle = styled.h2`
  text-align: center;
  color: #333;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 40px;
  background: linear-gradient(135deg, #e63946, #046A38);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;

  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 30px;
  }

  @media (max-width: 576px) {
    font-size: 1.5rem;
    margin-bottom: 20px;
  }
`;

const LogosContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  max-width: 1200px;
  width: 100%;

  @media (max-width: 1024px) {
    gap: 25px;
  }

  @media (max-width: 768px) {
    gap: 20px;
    justify-content: space-around;
  }

  @media (max-width: 576px) {
    /* Option mobile : scroll horizontal au lieu de stack vertical */
    flex-direction: row;
    gap: 15px;
    overflow-x: auto;
    justify-content: flex-start;
    padding: 0 10px;
    
    /* Custom scrollbar pour mobile */
    &::-webkit-scrollbar {
      height: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }
`;

const LogoLink = styled.a`
  display: inline-block;
  transition: all 0.3s ease;
  text-decoration: none;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  background: white;
  flex-shrink: 0; /* Empêche la réduction sur mobile */

  &:hover {
    transform: translateY(-5px) scale(1.02);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 768px) {
    &:hover {
      transform: translateY(-2px) scale(1.01);
    }
  }

  @media (max-width: 576px) {
    /* Assure une taille minimale sur mobile */
    min-width: 120px;
  }
`;

const LogoContainer = styled.div`
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 12px;
  transition: all 0.3s ease;

  @media (max-width: 768px) {
    padding: 12px;
  }

  @media (max-width: 576px) {
    padding: 10px;
  }
`;

const LogoImage = styled.img`
  height: 180px;
  width: 180px;
  object-fit: contain;
  transition: all 0.3s ease;

  @media (max-width: 1024px) {
    height: 150px;
    width: 150px;
  }

  @media (max-width: 768px) {
    height: 120px;
    width: 120px;
  }

  @media (max-width: 576px) {
    height: 100px;
    width: 100px;
  }

  @media (max-width: 400px) {
    height: 80px;
    width: 80px;
  }
`;



const LogoBanner = () => {
  const logos = [
    {
      id: 1,
      name: "Logo 1",
      imageUrl: "../assets/images/image27.png",
      url: "/"
    },
    {
      id: 2,
      name: "Logo 2",
      imageUrl: "../assets/images/Logo - CINEF FORMATION.png",
      url: "http://cinef-bj.com/formations"
    },
    {
      id: 3,
      name: "Logo 3",
      imageUrl: "../assets/images/Logo - CINEF TP.png",
      url: "http://cinef-bj.com/recrutement"
    },
    {
      id: 4,
      name: "Logo 4",
      imageUrl: "../assets/images/Logo - CINEF TECH.png",
      url: "http://cinf.app"
    },
  ];

  return (
    <BannerWrapper>
      <BannerTitle>Nos Partenaires & Filiales</BannerTitle>
      <LogosContainer>
        {logos.map((logo) => (
          <LogoLink
            key={logo.id}
            href={logo.url}
            target="_blank"
            rel="noopener noreferrer"
            title={`Visiter ${logo.name}`}
          >
            <LogoContainer>
              <LogoImage
                src={logo.imageUrl}
                alt={logo.name}
                loading="lazy"
              />
            </LogoContainer>
          </LogoLink>
        ))}
      </LogosContainer>
    </BannerWrapper>
  );
};

export default LogoBanner;